export default "__VITE_ASSET__2YQW_lw2__"